export default {
  dashboardBorrowerCount: null,
  dashboardOutstandingAmount: null,
  dashboardLoanAmount: null,
  dashboardProsecutionCount: null,
  dashboardLoanSpending: null,
  dashboardPaymentDue: null,
  dashboardDebtTracking: null,
  dashboardStageAgings: null,
  dashboardBorrowers: [],
  dashboardLoanAmountBorrowers: [],
  dashboardOutstandingRemainBorrowers: [],
  dashboardProsecutionBorrowers: [],
  dashboardLoanSpendingBorrowers: [],
  dashboardPaymentDueBorrowers: [],
  dashboardStageAgingNormalBorrowers: [],
  dashboardStageAgingAllBorrowers: [],
  dashboardStageAging1Borrowers: [],
  dashboardStageAging2Borrowers: [],
  dashboardStageAging3Borrowers: [],
  dashboardFollowUpBorrowers: [],
  dashboardMonthlyPaymentHistories: [],
}
